import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "48",
  height: "48",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M7.06897 18L2 23.069L7.06897 28.1379M38.931 18L44 23.069L38.931 28.1379M14 24C14 22.1362 14 21.2044 14.3045 20.4693C14.7105 19.4892 15.4892 18.7105 16.4693 18.3045C17.2044 18 18.1362 18 20 18L26 18C27.8638 18 28.7957 18 29.5307 18.3045C30.5108 18.7105 31.2895 19.4892 31.6955 20.4693C32 21.2044 32 22.1362 32 24C32 25.8638 32 26.7956 31.6955 27.5307C31.2895 28.5108 30.5108 29.2895 29.5307 29.6955C28.7957 30 27.8638 30 26 30L20 30C18.1362 30 17.2044 30 16.4693 29.6955C15.4892 29.2895 14.7105 28.5108 14.3045 27.5307C14 26.7956 14 25.8638 14 24Z",
  stroke: "black",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1 /* HOISTED */)
const _hoisted_3 = [
  _hoisted_2
]


export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  props: {
  fillColor: {
    type: String,
    required: false,
    default: 'white',
  },
  strokeColor: {
    type: String,
    required: false,
    default: 'white',
  },
},
  setup(__props) {

const props = __props;



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
}

})